import { render, staticRenderFns } from "./exam-staff.vue?vue&type=template&id=dd201e92&scoped=true&"
import script from "./exam-staff.vue?vue&type=script&lang=js&"
export * from "./exam-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd201e92",
  null
  
)

export default component.exports